import SplitPageHero from '../common/SplitPageHero'
import { achievementsHero } from '../../data/achievementsPageData'

const achievementsHeroImage = '/assets/achievements-hero-bg.png'

function AchievementsPageHero() {
  const { eyebrow, titleLine1, titleAccent, description, primaryCta, secondaryCta } =
    achievementsHero

  return (
    <SplitPageHero
      id="achievements-page-heading"
      eyebrow={eyebrow}
      title={
        <>
          {titleLine1}{' '}
          <span className="split-page-hero__title-accent">{titleAccent}</span>
        </>
      }
      description={description}
      image={achievementsHeroImage}
      imageAlt="Industrial warehouse with steel coils and metal materials"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    />
  )
}

export default AchievementsPageHero
